module.exports = __webpack_public_path__ + "static/media/picto-white-fast.9cf40273.png";